import type { Attribute } from "@/types/attribute";
import type { ColumnDef } from "../../ColumnModel";
import type { Row } from "../../RowModel";

export function useDefaultReadOnlyColumnBuilder() {
    return {
        build: (isVisible: boolean, attribute: Attribute): ColumnDef => {
            return {
                id: attribute.id.toString(),
                header: attribute.name,
                isVisible: isVisible,
                cssColDef: "150px",
                isRight: false,
                isReadOnly: true,
                getSortValue: ({ row }: { row: Row }) => {
                    return row.data.title;
                },
                getGroupHeader: ({ row }: { row: Row }) => {
                    return row.data.title;
                },
                cell: ({ row }: { row: Row }) => {
                    const customAttributeValues = row.data.customAttributeValues || []; // this can be null for new rows
                    const customAttributeValue = customAttributeValues.find((x: any) => x.id === attribute.id);
                    return (
                        <div className="px-3 flex items-center h-full text-sm">
                            <div className="truncate" title={customAttributeValue?.value}>
                                {customAttributeValue?.value}
                            </div>
                        </div>
                    );
                },
            };
        },
    };
}
